import { useQuery } from 'react-query';
import AsnAPI, { AsnResponse } from '../../Api/asn';
import { ASN_QUERY_KEYS } from './asnQueryKeys';

/**
 * Fetches ASN details for a purchase order via React Query.
 *
 * @param userId - User identifier.
 * @param poNumber - Purchase order number.
 * @param enabled - When false, the query does not run. Defaults to true.
 * @returns React Query result for {@link AsnResponse}.
 */
export const useGetAsnByPoNumber = (
  userId: string,
  poNumber: string,
  enabled = true,
) =>
  useQuery<AsnResponse>(
    ASN_QUERY_KEYS.byPoNumber(userId, poNumber),
    () => AsnAPI.getAsnByPoNumber(userId, poNumber),
    {
      enabled: enabled && !!userId && !!poNumber,
      retry: false,
    },
  );
